import { render, staticRenderFns } from "./form-password.generic.vue?vue&type=template&id=7e6957b8&"
import script from "./form-password.generic.vue?vue&type=script&lang=js&"
export * from "./form-password.generic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports